import {
  Loan,
  LoanParams,
  LoanRequest,
  LoanResponse,
} from '@/types/loan/index';
import { QueryRequest } from '@/utils/QueryRequest';

const BASE_URL = process.env.NEXT_PUBLIC_AFFILIATION_API_BASE_URL;
// Usado pelo sitemap: sem limite, uma API que não responde prende a requisição.
const SLUGS_TIMEOUT_MS = 10_000;

export async function getAllLoans(params?: { country: string }) {
  const queryRequest = new QueryRequest<Loan[]>(BASE_URL);
  queryRequest.addDefaultHeaders();
  queryRequest.addTags(['loan']);
  return queryRequest.get('loans', params);
}
export async function getLoanById(id: string) {
  const queryRequest = new QueryRequest<Loan>(BASE_URL);
  queryRequest.addDefaultHeaders();
  return queryRequest.get(`loans/${id}`);
}

export async function findLoans(params?: LoanParams) {
  const queryRequest = new QueryRequest<LoanResponse>(BASE_URL);
  queryRequest.addDefaultHeaders();
  const response = await queryRequest.get(`loans/find`, params);
  return response;
}

export async function getLoanBySlug(slug: string) {
  const queryRequest = new QueryRequest<Loan>(BASE_URL);
  queryRequest.addDefaultHeaders();
  queryRequest.addTags(['loan']);
  return queryRequest.get(`loans/slug/${slug}`);
}

export async function getLoanSlugsAndCountryCodes() {
  const queryRequest = new QueryRequest<LoanRequest>(BASE_URL);
  queryRequest.addDefaultHeaders();
  queryRequest.addTimeout(SLUGS_TIMEOUT_MS);
  return queryRequest.get('loans/slugs');
}

export async function getLoanFinancialInstitutions(params: {
  country: string;
}) {
  const financialRequest = new QueryRequest<string[]>(BASE_URL);
  financialRequest.addDefaultHeaders();
  financialRequest.addTags(['loan']);
  return financialRequest.get('loans/financialInstitutions', params);
}

export async function getLoanType(params?: LoanParams) {
  const queryRequest = new QueryRequest<string[]>(BASE_URL);
  queryRequest.addDefaultHeaders();
  return queryRequest.get('loans/types', params);
}
